module.exports = __webpack_public_path__ + "img/Lego_Adults_cs.e90fd221.png";